import {
  ArticlesFromArticleGroupQuery,
  ArticlesFromArticleGroupQueryVariables
} from './__generated__/ArticlesFromArticleGroupQuery';
import { useQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { ARTICLES_FROM_ARTICLE_GROUP_QUERY } from './articlesFromArticleGroup.query';

export const useArticlesFromArticleGroupQuery = (variables: ArticlesFromArticleGroupQueryVariables) => {
  return useQuery<ArticlesFromArticleGroupQuery>(ARTICLES_FROM_ARTICLE_GROUP_QUERY, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
